import { Mail, MessageCircle, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ContactChannel } from "./ContactChannel";
import { ContactForm } from "./ContactForm";

/**
 * La sección de contacto del final de la tienda: a la izquierda cómo
 * encontrarnos, a la derecha el formulario.
 *
 * Se apila en una columna bajo `lg`. Dos columnas en un teléfono dejarían
 * el formulario en la mitad de un ancho donde no cabe ni un correo.
 */
export function ContactSection() {
  const { t } = useTranslation();

  return (
    <section id="contacto" className="pb-20 sm:pb-28">
      <div className="mx-auto max-w-6xl px-6 sm:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-12">
          <div className="flex flex-col justify-center">
            <p className="text-ds-label font-bold uppercase tracking-ds-label-wide text-ds-violet-pop">
              {t("Contacto")}
            </p>

            <h2 className="mt-4 text-[28px] font-light leading-[1.1] tracking-tight text-ds-ink sm:text-ds-h2">
              {t("¿Tienes preguntas?")}
              <br />
              <span className="font-semibold">{t("Hablemos.")}</span>
            </h2>

            <p className="mt-4 max-w-sm text-[14px] leading-relaxed text-ds-ink-3">
              {t(
                "Nuestro equipo está listo para ayudarte. Escríbenos y te respondemos a la brevedad.",
              )}
            </p>

            <div className="mt-8 grid gap-4">
              <ContactChannel
                icon={<Mail aria-hidden="true" />}
                label={t("Correo")}
                value="hola@itsthebest1111.com"
              />
              <ContactChannel
                icon={<MessageCircle aria-hidden="true" />}
                label="WhatsApp"
                value="+52 55 3385 1066"
              />
              <ContactChannel
                icon={<Users aria-hidden="true" />}
                label={t("Comunidad")}
                value={t("Miembros en crecimiento")}
              />
            </div>
          </div>

          <ContactForm />
        </div>
      </div>
    </section>
  );
}
